import React, { createContext, useContext, useState } from 'react'

export type ChatNameUpdater = (chatName: string) => void

export type ChatNameState = {
  chatName: string
  setChatName: (chatName: string) => void
  updateChatName: ChatNameUpdater
  setUpdateChatName: (updateChatName: ChatNameUpdater) => void
}

const initialChatNameState: ChatNameState = {
  chatName: '',
  setChatName: () => {
    return
  },
  updateChatName: () => {
    return
  },
  setUpdateChatName: () => {
    return
  },
}

const ChatNameContext = createContext<ChatNameState>(initialChatNameState)

export const useChatNameContext = (): ChatNameState =>
  useContext(ChatNameContext)

export const ChatNameProvider = ({
  children,
}: React.PropsWithChildren): JSX.Element => {
  const [chatName, setChatName] = useState('')
  const [updateChatName, setUpdateChatName] = useState<ChatNameUpdater>(() => {
    return
  })

  return (
    <ChatNameContext.Provider
      value={{
        chatName,
        setChatName,
        updateChatName,
        setUpdateChatName,
      }}
    >
      {children}
    </ChatNameContext.Provider>
  )
}
